import React from "react";
import {
  Toolbar,
  ToolbarGroup,
  ToolbarItem,
  Level,
  LevelItem,
} from "@patternfly/react-core";
import FilterInput from "../general/FilterInput";
import Pagination from "../general/Pagination";

export default (props) => {
  const levelStyle = {
    backgroundColor: "#fff",
    paddingTop: "1rem",
    paddingBottom: "1rem",
    paddingLeft: "1rem",
    paddingRight: "1rem",
    borderBottom: "1px solid #ccc",
  };

  return (
    <Level hasGutter style={levelStyle}>
      <LevelItem>
        <Toolbar className="view-toolbar pf-u-px-md pf-u-py-md">
          <ToolbarGroup>
            <ToolbarItem className="pf-u-mr-md">
              <FilterInput
                itemName={"Product"}
                onChange={props.handleFilterValueChange}
              />
            </ToolbarItem>
          </ToolbarGroup>
        </Toolbar>
      </LevelItem>
      <LevelItem>
        <Pagination
          itemCount={props.itemCount}
          perPage={props.perPage}
          page={props.page}
          setPageContent={props.setPageContent}
          allPageContent={props.allPageContent}
          id="product-usage-list"
        />
      </LevelItem>
    </Level>
  );
};
